<template>
  <div class="phone-number-input">
    <VInput
      :messages="messages"
      :error="hasError"
      class="v-text-field--outlined mb-1"
    >
      <label
        :for="id"
        ref="label"
        class="phone-number-input__placeholder"
        v-html="placeholderComputed"
      />
      <VuePhoneNumberInput
        class="vue_phone_number_input"
        v-model="phone"
        @update="onchangePhone"
        :no-validator-state="true"
        :color="inputColor"
        :default-country-code="defaultCountry"
        :translations="translations"
      />
      <fieldset class="br-5">
        <!-- eslint-disable-next-line -->
        <legend v-html="legendComputed" />
      </fieldset>
    </VInput>
  </div>
</template>

<script>
import parsePhoneNumber from 'libphonenumber-js';

const codeLengthToOffset = {
  default: '80px',
  1: '80px',
  2: '85px',
  3: '90px',
  4: '95px',
};

export default {
  name: 'PhoneNumberInput',
  props: {
    value: {
      required: true,
      validator: (p) => typeof p === 'string' || p === null,
    },
    label: {
      type: String,
      default: 'phone',
    },
    required: {
      type: Boolean,
      default: false,
    },
    autoDefaultCountry: {
      type: Boolean,
      default: true,
    },
    errorMessages: {
      validator: () => true,
      default: null,
    },
    defaultCountry: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      id: null,
      phone: this.value,
      isFocused: false,
      error: null,
      phoneObj: null,
    };
  },
  computed: {
    inputColor() {
      if (!this.phoneObj || !this.phoneObj?.e164) {
        return 'dodgerblue';
      }

      if (this.phoneObj.isPossible) {
        return 'yellowgreen';
      }

      return 'orangered';
    },
    translatedLabel() {
      return this.label === 'phone' ? this.$t(this.label) : this.label;
    },
    messages() {
      return this.error || (this.errorMessages ? this.errorMessages.toString() : []);
    },
    legendComputed() {
      if (!this.value && !this.isFocused) {
        return '&#8203;';
      }

      let labelComputed = this.translatedLabel;

      if (this.required) {
        labelComputed += ' *';
      }
      return `&nbsp;${labelComputed}&nbsp;`;
    },
    placeholderComputed() {
      if (this.isFocused || this.phone) {
        return '';
      }
      let placeholderComputed = this.translatedLabel;
      if (this.required) {
        placeholderComputed += ' *';
      }
      if (this.hasError) {
        placeholderComputed = `<span class="red--text">${placeholderComputed}</span>`;
      }
      return placeholderComputed;
    },
    hasError() {
      return this.errorMessages !== null || this.error !== null;
    },
    translations() {
      return this.$i18n.locale === 'ru'
        ? {
          countrySelectorLabel: 'Код страны',
          countrySelectorError: 'Выберите код страны',
          phoneNumberLabel: 'Номер телефона',
          example: 'Например :',
        }
        : {
          countrySelectorLabel: 'Country code',
          countrySelectorError: 'Choose country code',
          phoneNumberLabel: 'Phone number',
          example: 'Example :',
        };
    },
  },
  watch: {
    value(v) {
      if (!this.phone) {
        this.phone = typeof v !== 'string' ? '' : v;
      }
    },
  },
  mounted() {
    // eslint-disable-next-line no-underscore-dangle
    // this.id = this._uid;
    // const el = this.$el.getElementsByClassName('vue_phone_number_input')[0];
    // // const el = this.$el.getElementsByClassName('vti__input')[0];
    // el.id = this.id;
    // el.dispatchEvent(new Event('input', { bubbles: true }));
    // el.onfocus = () => {
    //   this.isFocused = true;
    // };
    // el.onblur = () => {
    //   this.isFocused = false;
    //   this.onBlur();///
    // };
  },
  methods: {
    onInput(phone, phoneObj) {
      this.phoneObj = phoneObj;
    },
    onchangePhone(v) {
      if (!v) {
        return;
      }

      if (!!v.e164 && !!v.countryCode) {
        const parsed = parsePhoneNumber(v.e164, v.countryCode);
        v.isPossible = parsed.isPossible();

        if (v.isPossible) {
          this.$emit('input', v.e164);
        } else {
          this.$emit('input', null);
        }
      } else {
        v.isPossible = false;
        this.$emit('input', null);
      }

      this.phoneObj = v;
    },
    onBlur() {
      if (this.phoneObj.isPossible) {
        this.error = null;
        this.$emit('input', this.phoneObj.number.international);
      } else {
        this.$emit('input', null);
        this.error = this.$t('error');
      }
    },
    handleCountryChange(country) {
      this.$refs.label.style.left = codeLengthToOffset[country.dialCode.length]
        ?? codeLengthToOffset.default;
    },
  },
};
</script>

<style lang="scss">
.phone-number-input {
  &__placeholder {
    position: absolute;
    top: 9px;
    left: 78px;
    color: rgba(0, 0, 0, 0.6) !important;
    cursor: text;
  }
  fieldset {
    font-size: 12px;
    color: #484848;
  }
  .error--text {
    fieldset {
      border-color: red !important;
      color: red !important;
    }
  }
  &__input {
    width: 100%;
    input {
      margin-top: 11px !important;
      margin-right: 13px;
      height: 20px;
    }
  }
  .v-input__slot {
    min-height: 40px !important;
  }
  .v-messages {
    margin-top: 3px;
    padding: 0 12px;
  }
  &:focus-within {
    fieldset {
      border-color: rgb(10, 130, 217) !important;
      color: rgb(10, 130, 217) !important;
    }
  }
  *:focus {
    outline: none;
  }
}
.vue-tel-input {
  border: none !important;
  box-shadow: none !important;
}

.br-5 {
  border-radius: 5px;
}

.country-selector__label {
  display: none !important;
}
.country-selector__input {
  padding-top: 0 !important;
}
.country-selector__country-flag {
  top: 12px !important;
}
.select-country-container {
  flex: 0 0 80px !important;
  width: 80px !important;
  min-width: 80px !important;
  max-width: 80px !important;
}
</style>

<i18n locale="en" lang="yaml">
phone: Phone number
error: Incorrect phone number
</i18n>

<i18n locale="ru" lang="yaml">
phone: Телефон
error: Неправильный номер телефона
</i18n>
